import {
  CREATEPATIENTBLOODGROUP, GETPATIENTBLOODGROUP, GETPATIENTBLOODGROUPBYID, UPDATEPATIENTBLOODGROUP, DELETEPATIENTBLOODGROUP,
  CREATEPATIENTFAMILYRELATIONSHIP, GETPATIENTFAMILYRELATIONSHIP, GETPATIENTFAMILYRELATIONSHIPBYID, UPDATEPATIENTFAMILYRELATIONSHIP, DELETEPATIENTFAMILYRELATIONSHIP,
  CREATEPATIENTREFERRALTYPE, GETPATIENTREFERRALTYPE, GETPATIENTREFERRALTYPEBYID, UPDATEPATIENTREFERRALTYPE, DELETEPATIENTREFERRALTYPE,
  CREATEPATIENTVISITTYPE, GETPATIENTVISITTYPE, GETPATIENTVISITTYPEBYID, UPDATEPATIENTVISITTYPE, DELETEPATIENTVISITTYPE,
  CREATEPATIENTQUEUEPRIORITY, GETPATIENTQUEUEPRIORITY, GETPATIENTQUEUEPRIORITYBYID, UPDATEPATIENTQUEUEPRIORITY, DELETEPATIENTQUEUEPRIORITY,
  CREATEPATIENTPATIENTTYPE, GETPATIENTPATIENTTYPE, GETPATIENTPATIENTTYPEBYID, UPDATEPATIENTPATIENTTYPE, DELETEPATIENTPATIENTTYPE,
  CREATEPATIENTADMISSIONTYPE, GETPATIENTADMISSIONTYPE, GETPATIENTADMISSIONTYPEBYID, UPDATEPATIENTADMISSIONTYPE, DELETEPATIENTADMISSIONTYPE,
  CREATEPATIENTARRIVALMODE, GETPATIENTARRIVALMODE, GETPATIENTARRIVALMODEBYID, UPDATEPATIENTARRIVALMODE, DELETEPATIENTARRIVALMODE,
  CREATEPATIENTTRIAGECATEGORY, GETPATIENTTRIAGECATEGORY, GETPATIENTTRIAGECATEGORYBYID, UPDATEPATIENTTRIAGECATEGORY, DELETEPATIENTTRIAGECATEGORY,
  CREATEPATIENTFAMILYCATEGORY, GETPATIENTFAMILYCATEGORY, GETPATIENTFAMILYCATEGORYBYID, UPDATEPATIENTFAMILYCATEGORY, DELETEPATIENTFAMILYCATEGORY,
  CREATEPATIENTVISATYPE, GETPATIENTVISATYPE, GETPATIENTVISATYPEBYID, UPDATEPATIENTVISATYPE, DELETEPATIENTVISATYPE,
    CREATEPATIENTPACKAGETYPE, GETPATIENTPACKAGETYPE, GETPATIENTPACKAGETYPEBYID, UPDATEPATIENTPACKAGETYPE, DELETEPATIENTPACKAGETYPE,
  CREATEPATIENTUHID, GETPATIENTUHID, GETPATIENTUHIDBYID, UPDATEPATIENTUHID, DELETEPATIENTUHID,
  CREATEVISITSTATUS, GETVISITSTATUS, GETVISITSTATUSBYID, UPDATEVISITSTATUS, DELETEVISITSTATUS,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    /* BLOOD GROUP */
    case CREATEPATIENTBLOODGROUP:
      return { ...state, patientBloodGroupSaveStatus: action.payload.success };
    case GETPATIENTBLOODGROUP:
      return { ...state, patientBloodGroupList: action.payload.data };
    case GETPATIENTBLOODGROUPBYID:
      return { ...state, patientBloodGroupDetail: action.payload.data };
    case UPDATEPATIENTBLOODGROUP:
      return { ...state, patientBloodGroupUpdateStatus: action.payload.success };
    case DELETEPATIENTBLOODGROUP:
      return { ...state, patientBloodGroupDeleteStatus: action.payload.success };

    /* FAMILY RELATIONSHIP */
    case CREATEPATIENTFAMILYRELATIONSHIP:
      return { ...state, patientFamilyRelationshipSaveStatus: action.payload.success };
    case GETPATIENTFAMILYRELATIONSHIP:
      return { ...state, patientFamilyRelationshipList: action.payload.data };
    case GETPATIENTFAMILYRELATIONSHIPBYID:
      return { ...state, patientFamilyRelationshipDetail: action.payload.data };
    case UPDATEPATIENTFAMILYRELATIONSHIP:
      return { ...state, patientFamilyRelationshipUpdateStatus: action.payload.success };
    case DELETEPATIENTFAMILYRELATIONSHIP:
      return { ...state, patientFamilyRelationshipDeleteStatus: action.payload.success };

    /* REFERRAL TYPE */
    case CREATEPATIENTREFERRALTYPE:
      return { ...state, patientReferralTypeSaveStatus: action.payload.success };
    case GETPATIENTREFERRALTYPE:
      return { ...state, patientReferralTypeList: action.payload.data };
    case GETPATIENTREFERRALTYPEBYID:
      return { ...state, patientReferralTypeDetail: action.payload.data };
    case UPDATEPATIENTREFERRALTYPE:
      return { ...state, patientReferralTypeUpdateStatus: action.payload.success };
    case DELETEPATIENTREFERRALTYPE:
      return { ...state, patientReferralTypeDeleteStatus: action.payload.success };

    /* VISIT TYPE */
    case CREATEPATIENTVISITTYPE:
      return { ...state, patientVisitTypeSaveStatus: action.payload.success };
    case GETPATIENTVISITTYPE:
      return { ...state, patientVisitTypeList: action.payload.data };
    case GETPATIENTVISITTYPEBYID:
      return { ...state, patientVisitTypeDetail: action.payload.data };
    case UPDATEPATIENTVISITTYPE:
      return { ...state, patientVisitTypeUpdateStatus: action.payload.success };
    case DELETEPATIENTVISITTYPE:
      return { ...state, patientVisitTypeDeleteStatus: action.payload.success };

    /* QUEUE PRIORITY */
    case CREATEPATIENTQUEUEPRIORITY:
      return { ...state, patientQueuePrioritySaveStatus: action.payload.success };
    case GETPATIENTQUEUEPRIORITY:
      return { ...state, patientQueuePriorityList: action.payload.data };
    case GETPATIENTQUEUEPRIORITYBYID:
      return { ...state, patientQueuePriorityDetail: action.payload.data };
    case UPDATEPATIENTQUEUEPRIORITY:
      return { ...state, patientQueuePriorityUpdateStatus: action.payload.success };
    case DELETEPATIENTQUEUEPRIORITY:
      return { ...state, patientQueuePriorityDeleteStatus: action.payload.success };

    /* PATIENT TYPE */
    case CREATEPATIENTPATIENTTYPE:
      return { ...state, patientPatientTypeSaveStatus: action.payload.success };
    case GETPATIENTPATIENTTYPE:
      return { ...state, patientPatientTypeList: action.payload.data };
    case GETPATIENTPATIENTTYPEBYID:
      return { ...state, patientPatientTypeDetail: action.payload.data };
    case UPDATEPATIENTPATIENTTYPE:
      return { ...state, patientPatientTypeUpdateStatus: action.payload.success };
    case DELETEPATIENTPATIENTTYPE:
      return { ...state, patientPatientTypeDeleteStatus: action.payload.success };

    /* ADMISSION TYPE */
    case CREATEPATIENTADMISSIONTYPE:
      return { ...state, patientAdmissionTypeSaveStatus: action.payload.success };
    case GETPATIENTADMISSIONTYPE:
      return { ...state, patientAdmissionTypeList: action.payload.data };
    case GETPATIENTADMISSIONTYPEBYID:
      return { ...state, patientAdmissionTypeDetail: action.payload.data };
    case UPDATEPATIENTADMISSIONTYPE:
      return { ...state, patientAdmissionTypeUpdateStatus: action.payload.success };
    case DELETEPATIENTADMISSIONTYPE:
      return { ...state, patientAdmissionTypeDeleteStatus: action.payload.success };

    /* ARRIVAL MODE */
    case CREATEPATIENTARRIVALMODE:
      return { ...state, patientArrivalModeSaveStatus: action.payload.success };
    case GETPATIENTARRIVALMODE:
      return { ...state, patientArrivalModeList: action.payload.data };
    case GETPATIENTARRIVALMODEBYID:
      return { ...state, patientArrivalModeDetail: action.payload.data };
    case UPDATEPATIENTARRIVALMODE:
      return { ...state, patientArrivalModeUpdateStatus: action.payload.success };
    case DELETEPATIENTARRIVALMODE:
      return { ...state, patientArrivalModeDeleteStatus: action.payload.success };

    /* TRIAGE CATEGORY */
    case CREATEPATIENTTRIAGECATEGORY:
      return { ...state, patientTriageCategorySaveStatus: action.payload.success };
    case GETPATIENTTRIAGECATEGORY:
      return { ...state, patientTriageCategoryList: action.payload.data };
    case GETPATIENTTRIAGECATEGORYBYID:
      return { ...state, patientTriageCategoryDetail: action.payload.data };
    case UPDATEPATIENTTRIAGECATEGORY:
      return { ...state, patientTriageCategoryUpdateStatus: action.payload.success };
    case DELETEPATIENTTRIAGECATEGORY:
      return { ...state, patientTriageCategoryDeleteStatus: action.payload.success };

    /* FAMILY CATEGORY */
    case CREATEPATIENTFAMILYCATEGORY:
      return { ...state, patientFamilyCategorySaveStatus: action.payload.success };
    case GETPATIENTFAMILYCATEGORY:
      return { ...state, patientFamilyCategoryList: action.payload.data };
    case GETPATIENTFAMILYCATEGORYBYID:
      return { ...state, patientFamilyCategoryDetail: action.payload.data };
    case UPDATEPATIENTFAMILYCATEGORY:
      return { ...state, patientFamilyCategoryUpdateStatus: action.payload.success };
    case DELETEPATIENTFAMILYCATEGORY:
      return { ...state, patientFamilyCategoryDeleteStatus: action.payload.success };

    /* VISA TYPE */
    case CREATEPATIENTVISATYPE:
      return { ...state, patientVisaTypeSaveStatus: action.payload.success };
    case GETPATIENTVISATYPE:
      return { ...state, patientVisaTypeList: action.payload.data };
    case GETPATIENTVISATYPEBYID:
      return { ...state, patientVisaTypeDetail: action.payload.data };
    case UPDATEPATIENTVISATYPE:
      return { ...state, patientVisaTypeUpdateStatus: action.payload.success };
    case DELETEPATIENTVISATYPE:
      return { ...state, patientVisaTypeDeleteStatus: action.payload.success };
          /* PACKAGE TYPE */
    case CREATEPATIENTPACKAGETYPE:
      return { ...state, patientPackageTypeSaveStatus: action.payload.success };
    case GETPATIENTPACKAGETYPE:
      return { ...state, patientPackageTypeList: action.payload.data };
    case GETPATIENTPACKAGETYPEBYID:
      return { ...state, patientPackageTypeDetail: action.payload.data };
    case UPDATEPATIENTPACKAGETYPE:
      return { ...state, patientPackageTypeUpdateStatus: action.payload.success };
    case DELETEPATIENTPACKAGETYPE:
      return { ...state, patientPackageTypeDeleteStatus: action.payload.success };

    /* PATIENT UHID */
    case CREATEPATIENTUHID:
      return { ...state, patientUhidSaveStatus: action.payload.success };
    case GETPATIENTUHID:
      return { ...state, patientUhidList: action.payload.data };
    case GETPATIENTUHIDBYID:
      return { ...state, patientUhidDetail: action.payload.data };
    case UPDATEPATIENTUHID:
      return { ...state, patientUhidUpdateStatus: action.payload.success };
    case DELETEPATIENTUHID:
      return { ...state, patientUhidDeleteStatus: action.payload.success };

    /* VISIT STATUS */
    case CREATEVISITSTATUS:
      return { ...state, visitStatusSaveStatus: action.payload.success };
    case GETVISITSTATUS:
      return { ...state, visitStatusList: action.payload.data };
    case GETVISITSTATUSBYID:
      return { ...state, visitStatusDetail: action.payload.data };
    case UPDATEVISITSTATUS:
      return { ...state, visitStatusUpdateStatus: action.payload.success };
    case DELETEVISITSTATUS:
      return { ...state, visitStatusDeleteStatus: action.payload.success };

    default:
      return state;
  }
}